import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const RequestedServiceCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Requested service",
    cell: (row) => {
      return row.shippingMethodNames?.[0] ?? "";
    },
  };
